var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0h18l4 4 4-4 4 4 4-4 4 4h22l2 2v40l-2 2H2l-2-2V2l2-2zm22 6.828l4-4 4 4 4-4L39.172 6h22l.828.828v4.758L60.414 10H3.586L2 11.586V2.828L2.828 2h16.344L24 6.828zM2 14.414v30.758l.828.828h58.344l.828-.828V14.414L59.586 12H4.414L2 14.414z",
    fill: "#fff"
  })));
}
export default new URL("/home/runner/_work/flux-app/flux-app/frontend/src/resources/assets/project_icon.svg", import.meta.url).toString();
export { SvgProjectIcon as ReactComponent };